const productsInit = (block) => {
    const sliders = block ? Array.from(block[0].querySelectorAll(".bn-products .swiper")) : Array.from(
        document.querySelectorAll(".bn-products .swiper")
    );

    if (sliders.length) {
        sliders.forEach((slider) => {
            const sliderWrapper = slider.closest(".bn-products__section");
            const activeSlides = Number.parseInt(slider.dataset.activeSlides || "3", 10);
            const initialSlide = Number.parseInt(slider.dataset.initialSlide || "0", 10);
            const sliderVariant = slider.dataset.sliderVariant || "default";
            const disableDesktopSlider = slider.dataset.disableDesktop === "1";
            const disableTabletSlider = slider.dataset.disableTablet === "1";
            const isTwoUpSlider = sliderVariant === "two-up";
            const useSingleSlideUntilDesktop = isTwoUpSlider;
            const disableFromBreakpoint = disableTabletSlider ? 992 : (disableDesktopSlider ? 1200 : null);
            const disableFromMedia = disableFromBreakpoint ? window.matchMedia(`(min-width: ${disableFromBreakpoint}px)`) : null;

            if (!sliderWrapper) {
                return;
            }

            const sliderConfig = {
                observer: true,
                observeSlideChildren: true,
                centeredSlides: false,
                loop: true,
                watchSlidesProgress: true,
                initialSlide,
                slidesPerView: 1,
                spaceBetween: 20,
                allowTouchMove: slider.dataset.allowtouchmove === "0",
                navigation: {
                    nextEl: sliderWrapper.querySelector(".swiper-button-next-a"),
                    prevEl: sliderWrapper.querySelector(".swiper-button-prev-a"),
                },
                breakpoints: {
                    768: {
                        slidesPerView: useSingleSlideUntilDesktop ? 1 : Math.min(2, activeSlides),
                        spaceBetween: 8,
                    },
                    992: {
                        slidesPerView: useSingleSlideUntilDesktop ? 1 : Math.min(2, activeSlides),
                        spaceBetween: 8,
                    },
                    1200: {
                        slidesPerView: isTwoUpSlider ? 2 : activeSlides,
                        spaceBetween: 8,
                    },
                }
            };

            let currentSlider = null;

            const initSlider = () => {
                if (currentSlider || (disableFromMedia && disableFromMedia.matches)) {
                    return;
                }

                currentSlider = new Swiper(slider, sliderConfig);
                currentSlider.on("observerUpdate", () => {
                    if (!currentSlider) {
                        return;
                    }

                    currentSlider.destroy(true, true);
                    currentSlider = null;
                    initSlider();
                });
            };

            const destroySlider = () => {
                if (!currentSlider) {
                    return;
                }

                currentSlider.destroy(true, true);
                currentSlider = null;
            };

            const syncSliderState = () => {
                if (disableFromMedia && disableFromMedia.matches) {
                    destroySlider();
                    return;
                }

                initSlider();
            };

            syncSliderState();

            if (disableFromMedia) {
                disableFromMedia.addEventListener("change", syncSliderState);
            }
        });
    }
};

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains("block-editor-page") && !document.body.classList.contains("block-editor-iframe__body")) {
        productsInit();
    } else if (window.acf) {
        window.acf.addAction("render_block_preview/type=bn/products", productsInit);
    }
});